/* requires:
polyfill.js
*/

// accordion Toggle
var accordionActiveClass = "is-open"
var forEach = function (array, callback, scope) {
  for (var i = 0; i < array.length; i++) {
    callback.call(scope, i, array[i]); // passes back stuff we need from the array
  }
};
forEach(document.querySelectorAll(".accordion .accordion-toggle"), function (index, element) {
  element.addEventListener('click', function(event) {
    //console.log(element.classList);
    if ( !element.closest(".accordion").classList.contains(accordionActiveClass) ) {
      var el = document.querySelectorAll(".accordion");
      var i; for (i = 0; i < el.length; i++) {
        el[i].classList.remove(accordionActiveClass)
      }
      element.closest(".accordion").classList.toggle(accordionActiveClass)
    } else
    if ( element.closest(".accordion").classList.contains(accordionActiveClass) ) {
      element.closest(".accordion").classList.remove(accordionActiveClass)
    }
  })
});